module.exports = __webpack_public_path__ + "img/woman-light-medium.754056d1.svg";